import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import api from '../config/api';
import { format } from 'date-fns';
import { Link } from 'react-router-dom';
import { FaUser, FaEnvelope, FaCrown, FaTrash, FaCheckCircle, FaClock } from 'react-icons/fa';
import './Profile.css';

const Profile = () => {
  const { currentUser, userProfile } = useAuth();
  const [myReports, setMyReports] = useState([]);
  const [loading, setLoading] = useState(true);
  const [stats, setStats] = useState({
    total: 0,
    cleaned: 0,
    pending: 0
  });

  useEffect(() => {
    const fetchMyReports = async () => {
      if (!currentUser) return;

      try {
        const reports = await api.getUserReports(currentUser.uid);
        setMyReports(reports);
        
        const cleaned = reports.filter(r => r.status === 'cleaned').length;
        setStats({
          total: reports.length,
          cleaned: cleaned,
          pending: reports.length - cleaned
        });
      } catch (error) {
        console.error('Error fetching reports:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchMyReports();
  }, [currentUser]);

  if (loading) {
    return (
      <div className="profile-page">
        <div className="spinner"></div>
      </div>
    );
  }

  return (
    <div className="profile-page">
      <div className="profile-container">
        <div className="profile-header">
          <div className="profile-avatar">
            <FaUser />
          </div>
          <div className="profile-info">
            <h1>{currentUser.displayName || 'User'}</h1>
            <p><FaEnvelope /> {currentUser.email}</p>
            {userProfile?.role === 'subscriber' && (
              <div className="subscriber-badge">
                <FaCrown /> Subscriber Account
              </div>
            )}
          </div>
        </div>

        <div className="profile-stats">
          <div className="profile-stat-card">
            <div className="stat-icon" style={{ backgroundColor: '#3498db' }}>
              <FaTrash />
            </div>
            <div>
              <h3>{stats.total}</h3>
              <p>Total Reports</p>
            </div>
          </div>

          <div className="profile-stat-card">
            <div className="stat-icon" style={{ backgroundColor: '#2ecc71' }}>
              <FaCheckCircle />
            </div>
            <div>
              <h3>{stats.cleaned}</h3>
              <p>Cleaned</p>
            </div>
          </div>

          <div className="profile-stat-card">
            <div className="stat-icon" style={{ backgroundColor: '#f39c12' }}>
              <FaClock />
            </div>
            <div>
              <h3>{stats.pending}</h3>
              <p>Pending</p>
            </div>
          </div>
        </div>

        <div className="profile-section">
          <h2>My Waste Reports</h2>
          {myReports.length > 0 ? (
            <div className="reports-list">
              {myReports.map((report) => (
                <Link to={`/waste/${report.id}`} key={report.id} className="report-card">
                  <div className="report-image">
                    {report.photoURL ? (
                      <img src={report.photoURL} alt="Waste" />
                    ) : (
                      <div className="no-image">No Image</div>
                    )}
                  </div>
                  <div className="report-details">
                    <h3>{report.wasteType}</h3>
                    <p className="report-category">{report.category}</p>
                    <p className="report-date">
                      <FaClock /> {format(new Date(report.timestamp), 'MMM dd, yyyy HH:mm')}
                    </p>
                    <div className={`report-status ${report.status}`}>
                      {report.status === 'cleaned' ? <FaCheckCircle /> : null}
                      {report.status}
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          ) : (
            <div className="no-reports">
              <p>You haven't reported any waste yet.</p>
              <Link to="/report" className="btn btn-primary">
                Report Waste
              </Link>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Profile;
